import { useUserSimplifiedStore } from "../../Persistence/useUserSimplifiedStore";
import { useEffect } from "react";
import {
    deleteLocalStorageUserData,
    getLocalStorageUserId,
    useUpdateUserLocalStorageFromBE,
} from "@infrastructure/Persistence/LocalUserStorage";
import { UserState, useUserStore } from "@infrastructure/Persistence/UserState";
import { isPlatformChecktok, isPlatformTrucktour } from "@infrastructure/Services/EnvService";

let isLoading = false;

export function useUserUuid() {
    const { userId: storeUserId, setStoreUserId } = useUserSimplifiedStore();
    const { getUserPersonalizedDataFromBE } = useUpdateUserLocalStorageFromBE();
    const { userState, setUserState } = useUserStore();

    useEffect(() => {
        if (isPlatformChecktok || isPlatformTrucktour) {
            const localUserId = getLocalStorageUserId();

            if (
                localUserId &&
                userState !== UserState.PROFILE_STATUS_UNAUTHENTICATED
            ) {
                setStoreUserId(localUserId);
            } else if (!storeUserId && !isLoading) {
                deleteLocalStorageUserData();
                isLoading = true;
                setUserState(UserState.PROFILE_STATUS_UNAUTHENTICATED);
            }
        } else {
            getUserPersonalizedDataFromBE().then(
                (userId) => !!userId && setStoreUserId(userId),
            );
        }
    }, [userState]);

    return { storedUserId: storeUserId };
}

export function useIsCurrentUserId(userId: string = "") {
    const { storedUserId } = useUserUuid();
    return storedUserId === userId;
}
